<template>
  <div class="row mx-0">
    <div
      v-for="index in 3"
      :key="index"
      class="col-12 mb-sm-3 mb-lg-2 px-xl-0"
    >
      <div class="funnel-coffee-card funnel-card-bottom-border funnel-coffee-card-loader">
        <div class="col-12 px-0 signup-card-no-bg-container">
          <div class="signup-card-no-bg">
            <div class="row mx-0">
              <div class="col-6 col-md-4 pl-0 pr-2 signup-card-no-bg-imagery">
                <div class="signup-card-no-bg-top coffee-label-container skeleton" />
              </div>
              <div class="col-6 col-md-8 pl-2 pr-0 row mx-0 signup-card-no-bg-prod-details">
                <div class="col-12 px-0 signup-card-no-bg-prod-name-cnt">
                  <div class="row mx-0">
                    <div class="col-12 col-md-8 pr-2 pl-0">
                      <div class="skeleton signup-card-no-bg-name skeleton-text" />
                    </div>
                    <div class="d-none d-md-block col-md-4 pl-1 pr-0">
                      <div class="skeleton signup-card-no-bg-price skeleton-text" />
                    </div>
                  </div>
                </div>
                <div class="col-12 px-0">
                  <div class="skeleton skeleton-text taste-roast" />
                </div>
                <div class="col-12 px-0">
                  <div class="skeleton skeleton-text variants" />
                </div>
                <div class="col-12 px-0 t-left">
                  <div class="row mx-0 align-items-center">
                    <div class="skeleton origin-flag" />
                    <div class="skeleton origin-text" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SignupCoffeeRangeElementLoader',
}
</script>

<style lang="scss" scoped>
@use '../../../../assets/sass/inc/default/grid/grid-vue-mixins.scss' as *;

.funnel-coffee-card-loader {
  position: relative;
  padding: 0 20px;

  @media (max-width: 767px) {
    padding: 0 15px;
  }

  .skeleton {
    background: linear-gradient(90deg, #E9E9E9 25%, #F0F0F0 50%, #E9E9E9 75%);
    background-size: 200% 100%;
    animation: loading 1.5s infinite;
    border-radius: 4px;
  }

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }

    100% {
      background-position: -200% 0;
    }
  }

  &.funnel-card-bottom-border {
			border-bottom: 1px solid #F4F4F4;
			margin-top: 30px;
			padding-bottom: 30px;

    &.mt-0 {
      @media (max-width: 767px) { margin-top: 0px; }
    }

    &.no-border{
      border: none;
    }
	}

  .signup-card-no-bg-container {
    .signup-card-no-bg {
      width: 100%;

      .signup-card-no-bg-imagery {
        .signup-card-no-bg-top {
          height: 94px;
          border-radius: 8px;

          @media (min-width: 992px) {
            height: 190px;
          }

          @media (min-width: 1500px) {
            height: 224px;
          }
        }
      }

      .signup-card-no-bg-prod-details {
        @media (min-width: 576px) {
          margin-top: 15px;
        }

        .signup-card-no-bg-prod-name-cnt {
          margin-bottom: 15px;
        }

        .skeleton-text {
          height: 22px;
          width: 100%;
          margin-bottom: 8px;

          @media (min-width: 992px) {
            height: 24px;
          }

          &.signup-card-no-bg-name {
            width: 75%;
          }

          &.signup-card-no-bg-price {
            width: 60%;
            margin-left: auto;
          }

          &.taste-roast {
            width: 90%;
          }

          &.variants {
            width: 60%;
          }
        }

        .origin-flag {
          width: 27px;
          height: 20px;
          margin-right: 10px;
        }

        .origin-text {
          width: 40%;
          height: 14px;
        }
      }
    }
  }
}
</style>
